import { runDemo } from "../shared/demoRunner";
import { createCustomShaderScene } from "./scene";

runDemo({ createScene: createCustomShaderScene });
